import React from "react"
import { Container, Row, Col } from "reactstrap"
import fluxodLogo from "../../assets/images/new_logo_fluxod_40.png";
const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6}>{<p>
              © {new Date().getFullYear()} Fluxod
                </p>} 
            </Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block">
                <span className="logo-sm">
                  <img src={fluxodLogo} alt="" height="29" />
                </span>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
